import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getPurchaseOrderList } from 'src/redux/Actions/VehicleTracking';
import { useParams } from 'react-router-dom';
import Table from 'src/components/VehicleTrackingDetails/Tables/Table';
import { useMediaQuery } from '@mui/system';

function PurchaseOrderTable({ selectedPoIds, setSelectedPoIds }) {
  const dispatch = useDispatch();
  const { vehicleTrackingNumber, workflowStageId } = useParams();

  const vehicleTrackingDataReducer = useSelector(
    (state) => state?.VehicleTrackingReducer,
  );
  const authReducer = useSelector((state) => state.AuthReducer);
  const organisationId = authReducer.userData.organisations?.id;
  const themeColor = authReducer.userData.tenant?.theme;

  const isMobile = useMediaQuery('(max-width: 600px)');

  // Load initial purchase order data when component mounts
  useEffect(() => {
    dispatch(
      getPurchaseOrderList(
        vehicleTrackingNumber,
        organisationId,
        workflowStageId,
      ),
    );
  }, [dispatch, vehicleTrackingNumber, organisationId, workflowStageId]);

  // Get purchase order data from the reducer
  const purchaseOrderDetails =
    vehicleTrackingDataReducer?.poDetailData?.purchaseOrderDetails;

  useEffect(() => {
    if (purchaseOrderDetails?.length > 0) {
      // Set the initial selected PO IDs to all the PO numbers
      const initialSelectedPoIds = purchaseOrderDetails?.map(
        (poData) => poData?.po_number,
      );
      setSelectedPoIds(initialSelectedPoIds);
    }
  }, [purchaseOrderDetails]);

  // Define table headers
  const headers = [
    {
      label: 'PO Number',
      value: 'po_number',
    },
    {
      label: 'Invoice Number',
      value: 'invoice_number',
    },
    {
      label: 'E-Way Bill Number',
      value: 'eway_bill_number',
    },
    {
      label: 'Delivery Date',
      value: 'delivery_date',
    },
    {
      label: 'Vendor Name',
      value: 'vendor_name',
    },
    {
      label: 'Status',
      value: 'status',
    },
  ];

  // Handle checkbox changes
  const handlePocheckboxOnchange = (e) => {
    const poNumber = e.target.value;

    const updatedSelection = e.target.checked
      ? [...selectedPoIds, poNumber]
      : selectedPoIds.filter((id) => id !== poNumber);

    setSelectedPoIds(updatedSelection);
  };

  const renderTableContent = () => (
    <tbody>
      {purchaseOrderDetails?.length > 0 ? (
        purchaseOrderDetails.map((poData) => (
          <tr key={poData?.id}>
            {headers.map((header) => {
              const key = header.value;

              let content;
              if (key === 'po_number') {
                content = (
                  <>
                    <input
                      type="checkbox"
                      name="poCheckBox"
                      value={poData?.po_number}
                      onChange={handlePocheckboxOnchange}
                      checked={selectedPoIds.includes(poData?.po_number)}
                    />
                    <span className="text-sm">
                      {'  '}
                      {poData?.[key]}
                    </span>
                  </>
                );
              } else if (key === 'status') {
                content = (
                  <div
                    className={
                      poData?.status === 'cancelled'
                        ? 'text-sm'
                        : 'text-sm status-pill green'
                    }
                  >
                    {poData?.status}
                  </div>
                );
              } else {
                content = <span className="text-sm">{poData?.[key]}</span>;
              }

              return (
                <td key={`${poData?.id}-${poData?.material_description}`}>
                  {content}
                </td>
              );
            })}
          </tr>
        ))
      ) : (
        <tr>
          <td
            colSpan={headers?.length}
            className="no-data-found-message border-bottom"
          >
            <span className="text-sm">No Purchase Orders Found</span>
          </td>
        </tr>
      )}
    </tbody>
  );

  return (
    <>
      <div className="div-flex-row div-space-between section-title div-align-center">
        <div className="text-md text-semi-bold">Purchase Order</div>
        <span className={`${isMobile ? 'text-xs' : 'text-md'} text-semi-bold`}>
          Total Purchase Order: {purchaseOrderDetails?.length}
        </span>
      </div>
      <div
        className={`table-fixed-container theme-horizontal-scrollable-container-${themeColor}`}
      >
        <Table
          headers={headers}
          minCellWidth={100}
          tableContent={renderTableContent()}
        />
      </div>
    </>
  );
}

export default PurchaseOrderTable;
